<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsSmsService.showDetailedView"
         [ngStyle]="{width: settingsSmsService.showDetailedView ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-12">
                    <filter [tabHeading]="'Corporation'" [buildings]="[]"></filter>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsParcels'" [ngClass]="{'sk-loading': settingsSmsService.spinnerShow}">
                    <settings-sms-list></settings-sms-list>
                    <spinner [spinnerShow]="settingsSmsService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsSmsService.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="settingsSmsService.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar"
         *ngIf="settingsSmsService.showDetailedView">
        <settings-sms-detailed-view></settings-sms-detailed-view>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-sms/settings-sms.component.html